import axios from 'axios';
import {put} from 'redux-saga/effects';
import actions from '../../redux/auth/actions';
import { headers } from './resApiRequestor';

const timeout = 60000;
const apiUrl = process.env.REACT_APP_KOTLIN_API_URL;

export function* kotlinApiGet(uri, data) {
  const params = data ? toParams(data) : '';
  return yield fetch(`${apiUrl}${uri}?${params}`, {
    headers: headers,
    method: 'GET',
  });
}

export function* kotlinApiGetFile(uri, data) {
  const params = data ? toParams(data) : '';
  return yield fetch(`${apiUrl}${uri}?${params}`, {
    headers: headers,
    method: 'GET',
    responseType: 'blob',
  });
}

export function* kotlinApiPost(uri, data) {
  return yield fetch(`${apiUrl}${uri}`, {
    headers: headers,
    method: 'POST',
    data,
  });
}
export function* kotlinApiPostOtp(uri, data) {
  return yield fetch(`${apiUrl}${uri}`, {
    headers: headers,
    method: 'POST',
    data,
  });
}
export function* kotlinApiPutOtp(uri, data) {
  return yield fetch(`${apiUrl}${uri}`, {
    headers: headers,
    method: 'PUT',
    data,
  });
}
export function* kotlinApiPostBlob(uri, data) {
  return yield fetch(`${apiUrl}${uri}`, {
    headers: headers,
    method: 'POST',
    data,
    responseType: 'blob',
  });
}
export function* kotlinApiPostArrayBuffer(uri, data) {
  return yield fetch(`${apiUrl}${uri}`, {
    headers: headers,
    method: 'POST',
    data,
    responseType: 'arraybuffer',
  });
}
export function* kotlinApiPut(uri, data) {
  return yield fetch(`${apiUrl}${uri}`, {
    headers: headers,
    method: 'PUT',
    data,
  });
}

export function* kotlinApiDelete(uri, data) {
  return yield fetch(`${apiUrl}${uri}`, {
    headers: headers,
    method: 'DELETE',
    data,
  });
}

function toParams(data) {
  const params = new URLSearchParams();

  Object.entries(data).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach(val => {
        params.append(key, String(val));
      });
    } else if (value !== undefined && value !== null) {
      params.set(key, String(value));
    }
  });

  return params.toString();
}

function* forbidden() {
  yield localStorage.setItem('forbidToken', 1);
  yield put({
    type: actions.CHECK_AUTHORIZATION,
  });
}

export function* fetch(url, options) {
  const result = yield axios.request({
    ...options,
    url,
    baseURL: apiUrl,
    timeout: timeout,
    headers: headers
  }).then((res) => {
    return res;
  }).catch((error) => {
    return error
  })

  try {
    const response = result.status ? result : result.response ? result.response : null;
    if (!response) return null;
    if (response.status === 401 || response.status === 403) return yield forbidden()
    if (!response.data || response.data instanceof Blob) return response;

    return response;
    // Verify response data
    // const { payload } = verify(response.data, process.env.REACT_APP_ENV_KEY);
    // if (typeof payload === 'string') {
    //   try {
    //     const parsedPayload = JSON.parse(payload);
    //     return {...response, data: parsedPayload };
    //   } catch (e) {
    //     // Detect base64 the convert to blob
    //     return {...response, data: payload };
    //   }
    // }
    // return {...response, data: payload };
  } catch (error) {
    return error
  }
}
